import { DatePicker, DatePickerProps, Form } from "antd";
import { FormItemProps } from "antd/es/form";
import { FunctionComponent } from "react";
import { APPLICATION_DATE_FORMAT } from "../../utils/FormUtils";

export type DatePickerFormItemProps = DatePickerProps & FormItemProps & {
    testid?: string;
};

export const DatePickerFormItem: FunctionComponent<DatePickerFormItemProps> = ({ name, label, rules, picker, onChange, disabled, testid }) => {

    // rc-picker's DatePicker drops any unrecognized prop like "testid" before it reaches the DOM
    // (its root only forwards mouse handlers, its input only forwards a fixed known prop list).
    // "id" IS one of those known, forwarded props, so we use it as the e2e hook instead: the e2e
    // test should target this field via `#<id>` (CSS selector) rather than getByTestId.
    const id = testid ?? name;

    return (
        <Form.Item name={name.split(".")} label={label} rules={rules}>
            {picker === "year" ?
                (<DatePicker id={id} picker={picker} onChange={onChange} disabled={disabled} />)
                : (<DatePicker id={id} format={APPLICATION_DATE_FORMAT} picker={picker} onChange={onChange} disabled={disabled} />)}
        </Form.Item>
    );
}